/**
 * @author: Ronan
 * @param:
 */
import { Icon, Popconfirm } from 'antd';
import classNames from 'classnames/bind';
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../index.less';

const cx = classNames.bind(styles);

const addonAfter = WrappedComponent => class extends Component {
  // TODO: Handing name change here is only a fun experiment. It can also sync with redux to solve the issue
  constructor() {
    super();
    this.state = {
      newName: '',
    }
  }
  componentWillReceiveProps(nextProps) {
    // NOTE: We sync folder name after it was commited to backend
    if (this.props.name !== nextProps.name) {
      this.setState({ newName: nextProps.name });
    } else if (this.state.newName !== nextProps.name) {
      this.setState({ newName: nextProps.name });
    }
  }
  handleNameChange = e => this.setState({ newName: e.target.value })
  handleCancelClick = (e) => {
    e.stopPropagation();
    const { id, type, resetEditingFolder } = this.props;
    resetEditingFolder(id, type);
  }
  handleDeleteClick = (e) => {
    e.stopPropagation();
    const { id, type, deleteLocalFolder, tryDeleteFolder } = this.props;
    if (id < 0) {
      deleteLocalFolder(type);
    } else {
      tryDeleteFolder(id, type);
    }
  }
  handleEditClick = (e) => {
    e.stopPropagation();
    const { id, type, setEditingFolder } = this.props;
    setEditingFolder(id, type);
  }
  handleSaveClick = (e) => {
    e.stopPropagation();
    const { id, type, tryCommitNewFolder, tryCommitFolderName } = this.props;
    if (id < 0) {
      tryCommitNewFolder(type, this.state.newName);
    } else {
      tryCommitFolderName(id, type, this.state.newName);
    }
  }

  renderAddon = () => {
    const i18n = 'global.ui';
    const buttons = this.props.isEditing ? (
      <Fragment>
        <Icon className="cursor-pointer mr-sm" type="save" onClick={this.handleSaveClick} />
        <Icon className="cursor-pointer" type="close" onClick={this.handleCancelClick} />
      </Fragment>
    ) : (
        this.props.sharedBy === '' && (
          <Fragment>
            <Icon className="cursor-pointer mr-sm" type="edit" onClick={this.handleEditClick} />
            <Popconfirm
              cancelText={<FormattedMessage id={`${i18n}.button.cancel`} />}
              okText={<FormattedMessage id={`${i18n}.button.ok`} />}
              title={<FormattedMessage id={`${i18n}.dialog.deleteTitle`} />}
              onConfirm={this.handleDeleteClick}
              onCancel={e => e.stopPropagation()}
            >
              <Icon className="cursor-pointer" type="delete" onClick={e => e.stopPropagation()} />
            </Popconfirm>
          </Fragment>
        )
      );
    return <div className={cx('addonAfter')} >{buttons}</div>;
  }

  render() {
    const { newName } = this.state;
    return (
      <WrappedComponent
        {...this.props}
        addonAfter={this.renderAddon()}
        onNameChange={this.handleNameChange}
        newName={newName}
      />
    );
  }
};

export default addonAfter;



// WEBPACK FOOTER //
// ./src/views/ReportListSider/components/getAddonAfter.jsx